export enum AppEnvironment {
  Production = 'production',
  Staging = 'staging',
  Development = 'development',
}

export enum Platform {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}

export type ApiEnv = 'production' | 'staging';

export type CurrencyCodes = 'PLN' | 'BGN' | 'EUR' | 'KZT' | 'RON' | 'UAH' | 'USD' | 'UZS' | 'UYE';

export type LocationItem = {
  city?: string | undefined;
  cityId: number | null;
  description: string | undefined | null;
  district?: string | null;
  districtId: number | null;
  region: string | undefined | null;
  regionId: number | undefined | null;
  title: string | undefined;
  lat?: number | null;
  lon?: number | null;
  geoDescription?: string;
  radius?: number | null;
  zoom?: number | null;
};

export type LoggedUser = {
  userId?: number;
  userUuid?: string | null;
  userName?: string;
  userPerson?: string;
  userEmail?: string;
  userPhone?: string;
  userPhoneConfirmed?: string;
  userIsBusiness?: boolean;
  userBusinessStatus?: string;
  userSocialNetworkAccountType?: string;
  userPhoto?: string;
  userLocation?: LocationItem | null;
  showUserAds?: boolean;
  isFacebookIntegrated?: boolean;
  userIsRestricted?: boolean;
  protectPhoneInCategories?: number[];
  userIsPro?: boolean;
  isAnonymous?: boolean;
};

export type TrackEventFn = (
  name?: string,
  params?: Record<string, unknown>,
  touchPointButton?: string,
  trackLinkEventProps?: {
    trackLinkEvent?: boolean;
    linkCallBack?: (...args: any[]) => any;
  },
) => void;

export type TrackPageViewFn = (
  name?: string,
  params?: Record<string, unknown>,
  component?: React.ComponentType<any>,
  forceTracking?: boolean,
  setTouchPoint?: boolean,
) => void;

export type SetTouchPointPageFn = (page: string | null | undefined) => void;

export type GetPreviousTouchPointPageFn = () => string | null;

export type AtLeastOne<T, U = { [K in keyof T]: Pick<T, K> }> = Partial<T> & U[keyof U];

export type AuthContext = {
  authenticated: boolean;
};
